import { createContext } from 'react'

export type AuthCredentials = { email: string; password: string }

export const AuthCredentialsContext = createContext<{
  credentials: AuthCredentials
  setCredentials: (credentials: AuthCredentials) => void
} | null>(null)
